/** Keep following a long pricing check until a terminal version is visible. */
export function waitForTerminalAnalysis(opts: {
  subscribe: (onTerminal: () => void) => { close: () => void };
  isTerminal: () => Promise<boolean>;
  isCurrent: () => boolean;
  pollMs: number;
}): Promise<void> {
  return new Promise((resolve) => {
    const state: {
      settled: boolean;
      timer?: ReturnType<typeof setTimeout>;
      stream?: { close: () => void };
    } = { settled: false };
    const finish = (): void => {
      if (state.settled) return;
      state.settled = true;
      if (state.timer !== undefined) clearTimeout(state.timer);
      state.stream?.close();
      resolve();
    };
    const scheduleNextCheck = (): void => {
      if (state.settled) return;
      state.timer = setTimeout(() => void check(), opts.pollMs);
    };
    const check = async (): Promise<void> => {
      if (state.settled) return;
      if (!opts.isCurrent()) {
        finish();
        return;
      }
      try {
        if (await opts.isTerminal()) {
          finish();
          return;
        }
      } catch {
        // A failed status read is transient; the stream and next check remain active.
      }
      scheduleNextCheck();
    };
    state.stream = opts.subscribe(finish);
    if (state.settled) state.stream.close();
    else void check();
  });
}
